// import React from 'react'
import Content from "../../../../Components/Dashboard/Content/Content";
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Theme_Content from "../../../../Components/Dashboard/Content/Theme_Content";
import Loader from "../../../../Utils/Loader";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Pencil, Trash2, Users } from "lucide-react";
// import FullDataTable from "../../../../Components/ExtraComponents/Datatable/FullDataTable";
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable";
import { Get_All_SUBADMIN } from "../../../../ReduxStore/Slice/Subadmin/Subadminslice";
import { DELETE_USER_SERVICES } from "../../../../ReduxStore/Slice/Admin/AdminSlice";
import {
  GO_TO_DASHBOARDS,
  UPDATE_USER_ACTIVE_STATUS,
} from "../../../../ReduxStore/Slice/Admin/AdminSlice";
import { useDispatch, useSelector } from "react-redux";
import BasicDataTable from "../../../../Components/ExtraComponents/Datatable/BasicDataTable";
import Modal from "../../../../Components/ExtraComponents/Modal";
import { Get_Client_By_Subadmin_Id } from "../../../../ReduxStore/Slice/Admin/CreateSubadminSlice";
import {
  maskEmail,
  maskNumber,
  maskPassword,
} from "../../../../Utils/HideWIthStart";
import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";

import toast, { Toaster } from "react-hot-toast";

const AllSubadmin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const token = JSON.parse(localStorage.getItem("user_details")).token;

  const [showModal, setshowModal] = useState(false);

  const [originalData, setOriginalData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [PanelStatus, setPanelStatus] = useState("2");

  const [refresh, setrefresh] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

    const gotodashboard = JSON.parse(localStorage.getItem("user_details_goTo"));
  const isgotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));

  const [Addsubadmin, setAddsubadmin] = useState({
    loading: true,
    data: [],
  });

  const [SubAdminClients, setSubAdminClients] = useState({
    loading: true,
    data: [],
  });

  // ACTIVE USER TO API
  const activeUser = async (e, data) => {
    const originalStatus = e.target.checked;
    const req = {
      id: data._id,
      user_active_status: originalStatus ? "1" : "0",
    };

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to change the status for this user?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await dispatch(
          UPDATE_USER_ACTIVE_STATUS(req)
        ).unwrap();

        if (response.status) {
          toast.success(response.msg);
          setrefresh(!refresh); // refresh data
        } else {
          toast.error(response.msg);
          e.target.checked = !originalStatus; // revert on error
        }
      } catch (err) {
        toast.error("Something went wrong!");
        e.target.checked = !originalStatus; // revert on error
      }
    } else {
      e.target.checked = !originalStatus; // revert if user cancels
    }
  };

  // ✅ 1. DATA FETCH FUNCTION
  const data = async () => {
    setIsLoading(true); // start loader before fetching
    try {
      const response = await dispatch(Get_All_SUBADMIN()).unwrap();

      setAddsubadmin({
        loading: false,
        data: response.data,
      });

      setOriginalData(response.data);
    } catch (error) {
      console.error("Error fetching subadmins:", error);
      toast.error("Failed to load subadmins");
      setAddsubadmin({
        loading: false,
        data: [],
      });
    } finally {
      setIsLoading(false); // stop loader after fetch
    }
  };

  // ✅ 2. USE EFFECT
  useEffect(() => {
    data(); // fetch data initially + when refresh toggles
  }, [refresh]);

  // DELETE USET FUNCTION TO DELETE ALL SERVICES
  const Delete_user = async (id) => {
    var req1 = {
      id: id,
    };

    await dispatch(DELETE_USER_SERVICES(req1))
      .unwrap()
      .then((response) => {
        if (response.status) {
          setrefresh(!refresh);
        }
      });
  };

  const goToDashboard = async (asyncid, email) => {
    try {
      const req = { Email: email };
      const response = await dispatch(GO_TO_DASHBOARDS(req)).unwrap();

      if (response.status) {
        // Save admin’s route to return later
        localStorage.setItem("route", "/admin/allsubadmins");
        localStorage.setItem("gotodashboard", "true");

        localStorage.setItem(
          "user_details_goTo",
          JSON.stringify(response.data)
        );
        localStorage.setItem(
          "user_role_goTo",
          JSON.stringify(response.data.Role)
        );

        // Optionally keep the old user (admin) to restore later
        localStorage.setItem(
          "admin_backup",
          localStorage.getItem("user_details")
        );

        navigate("/subadmin/clients");
      } else {
        toast.error("Unable to open subadmin dashboard");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong while opening dashboard");
    }
  };

  // VIEW SUBADMIN CLIENTS BY SUBADMIN ID
  const ViewSubadminClients = async (id) => {
    setshowModal(true);

    await dispatch(Get_Client_By_Subadmin_Id({ id: id, token: token }))
      .unwrap()
      .then((response) => {
        if (response.status) {
          setSubAdminClients({
            loading: false,
            data: response.data,
          });
        } else {
          setSubAdminClients({
            loading: false,
            data: response.data,
          });
        }
      });
  };

  const columns = [
    {
      name: "User Name",
      selector: (row) => row.UserName,
      cell: (row) => (
        <>
          <img
            src={
              row.profileimg ||
              "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
            }
            alt="User Avatar"
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              marginRight: "10px",
            }}
          />
          <div>{row.UserName || "-"}</div>
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Full Name",
      selector: (row) => row.FullName,
      cell: (row) => <div>{row.FullName || "-"}</div>,
      sortable: true,
      width: "160px",
    },
    {
      name: "Email",
      selector: (row) => row.Email,
      cell: (row) => <span>{maskEmail(row.Email)}</span>,
      sortable: true,
      width: "170px",
    },
    {
      name: "Phone Number",
      selector: (row) => row.PhoneNo,
      cell: (row) => <span>{maskNumber(row.PhoneNo)}</span>,
      sortable: true,
      width: "170px",
    },

    {
      name: "Status",
      selector: (row) => row.ActiveStatus,
      cell: (row) => (
        <label>
          <input
            type="checkbox"
            className="toggle-checkbox"
            checked={row.ActiveStatus === "1"}
            onChange={(e) => activeUser(e, row)}
          />
          <div className="toggle-switch"></div>
        </label>
      ),
      sortable: true,
    },
    {
      name: "Clients",
      selector: () => null,
      cell: (row) => (
        <Users
          size={20}
          color="#198754"
          strokeWidth={2}
          className="mx-1"
          onClick={() => ViewSubadminClients(row._id)}
          title="View Clients"
          style={{ cursor: "pointer" }}
        />
      ),
      sortable: false,
    },
    {
      name: "Dashboard",
      selector: () => null,
      cell: (row) =>
        row.ActiveStatus === "0" ? (
          <span
            className="btn btn-new-block"
            style={{
              cursor: "not-allowed",
              color: "white",
              opacity: 0.6,
              backgroundColor: "red",
            }}
          >
            Dashboard
          </span>
        ) : (
          <span
            className="btn-success btn-sm btn btn-new-block"
            style={{ cursor: "pointer", color: "white" }}
            onClick={() => goToDashboard(row._id, row.Email)}
          >
            Dashboard
          </span>
        ),
      sortable: false,
    },
    {
      name: "Actions",
      selector: () => null,
      cell: (row) => (
        <div className="d-flex">
          {/* EDIT with navigate */}
          <span
            title="Edit"
            onClick={() => navigate(`/admin/editsubadmin/${row._id}`)}
            style={{ cursor: "pointer" }}
          >
            <Pencil
              size={20}
              color="#198754"
              strokeWidth={2}
              className="mx-1"
            />
          </span>

          {/* DELETE with Swal */}
          <span
            title="Delete"
            onClick={() => {
              Swal.fire({
                title: "Are you sure?",
                text: "This will permanently delete the user.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#6c757d",
                confirmButtonText: "Yes, delete it!",
              }).then((result) => {
                if (result.isConfirmed) {
                  Delete_user(row._id);
                  Swal.fire("Deleted!", "User has been deleted.", "success");
                }
              });
            }}
            style={{ cursor: "pointer" }}
          >
            <Trash2
              size={20}
              color="#d83131"
              strokeWidth={2}
              className="mx-1"
            />
          </span>
        </div>
      ),
      sortable: false,
      width: "100px",
    },
  ];

  const columns1 = [
    {
      name: "User Name",
      selector: (row) => row.UserName,
      cell: (row) => <span>{row.UserName || "-"}</span>,
      sortable: true,
    },
    {
      name: "Full Name",
      selector: (row) => row.FullName,
      cell: (row) => <span>{row.FullName || "-"}</span>,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.Email,
      cell: (row) => <span>{row.Email || "-"}</span>,
      sortable: true,
    },
    {
      name: "License Type",
      selector: (row) => row.license_type,
      cell: (row) => (
        <span>
          {row.license_type === "0"
            ? "2 Days Only"
            : row.license_type === "1"
            ? "Demo"
            : "Live"}
        </span>
      ),
      sortable: true,
    },
  ];

  useEffect(() => {
    const filteredData = originalData.filter((item) => {
      return (
        (PanelStatus === "2" || item.WebLoginStatus.includes(PanelStatus)) &&
        (searchInput === "" ||
          item.UserName.toLowerCase().includes(searchInput.toLowerCase()) ||
          item.Email.toLowerCase().includes(searchInput.toLowerCase()) ||
          item.PhoneNo.includes(searchInput))
      );
    });
    setAddsubadmin({
      loading: false,
      data: searchInput || PanelStatus !== "2" ? filteredData : originalData,
    });
  }, [searchInput, originalData, PanelStatus]);



  return (
    <>
      {Addsubadmin.loading ? (
        <Loader />
      ) : (
        <>
          <Content
            Page_title="All Subadmins"
            button_title="Add SubAdmin"
            route="/admin/allsubadmins/add"
          >
            <div className="mx-0 row filter-row">
              <div className="col-lg-12 d-flex ">
                <div className="mb-3 col-sm-5 col-10 me-2  ">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    className="form-control"
                    id="exampleFormControlInput1"
                  />
                </div>
                <div>
                  <button
                    className="btn btn-sm btn-primary"
                    title="Reset Filters"
                    onClick={() => {
                      setIsSpinning(true); // start spin

                      // reset filters
                      setSearchInput("");
                      setPanelStatus("2");

                      // refresh data
                      setrefresh((prev) => !prev);

                      // stop spin after short delay
                      setTimeout(() => setIsSpinning(false), 1000);
                    }}
                  >
                    <i
                      className={`fa fa-refresh ${isSpinning ? "spin" : ""}`}
                    ></i>
                  </button>
                </div>
              </div>
            </div>

            {/* <Table columns={columns} data={Addsubadmin?.data || []} /> */}

            {isLoading || isSpinning ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "300px" }}
              >
                <Loader />
              </div>
            ) : (
              <Table columns={columns} data={Addsubadmin?.data || []} />
            )}

            {showModal ? (
              <>
                <Modal
                  isOpen={showModal}
                  size="lg"
                  title="Client List"
                  hideBtn={true}
                  handleClose={() => setshowModal(false)}
                >
                  <Table
                    columns={columns1}
                    data={SubAdminClients?.data && SubAdminClients?.data}
                  />
                </Modal>
              </>
            ) : (
              ""
            )}
          </Content>
        </>
      )}
    </>
  );
};

export default AllSubadmin;
